import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error state matcher that shows errors immediately without requiring touched state */
export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    return !!control?.invalid;
  }
}
